import { render, staticRenderFns } from "./InstagramPageSelector.vue?vue&type=template&id=7281aba1&scoped=true"
import script from "./InstagramPageSelector.vue?vue&type=script&lang=ts"
export * from "./InstagramPageSelector.vue?vue&type=script&lang=ts"
import style0 from "./InstagramPageSelector.vue?vue&type=style&index=0&id=7281aba1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7281aba1",
  null
  
)

export default component.exports